import {
    ExcluirAtendimentoService,
    GetAtendimentoClienteService,
    ListarQuantidadeAtendimentosService,
    ListarJustificativaCancelamentoService,
    RemoverAtendimentoDoUsuarioAcompanhamentoService,
    RemoverAtendimentoDoUsuarioService,
    TranferirAtendimentoService,
    ListarAtendimentosService,
    ListarAtendimentosExportarExcelService,
} from "../../../Services/AtendimentoCliente/Atendimento/Atendimentoservices";
import {
    IListarTodosAtendimentos,
    ITranferirAtendimentoCliente,
} from "../../../Interfaces/AtendimentoCliente/Atendimento/AtendimentoInterfaces";
import { Controller } from "../../Controller";
import { TModoGestaoAtendimento } from "../../../Interfaces/AtendimentoCliente/GestaoDeAtendimento/GestaoDeAtendimentoInterfaces";

export async function TranferirAtendimentoController(
    tranferencia: ITranferirAtendimentoCliente
) {
    return Controller(
        TranferirAtendimentoService(tranferencia),
        "Atendimento Transferido com sucesso"
    );
}

export async function RemoverAtendimentoDoUsuarioController(IDCaso: number) {
    return Controller(
        RemoverAtendimentoDoUsuarioService(IDCaso),
        "Atendimento Removido de atendente com sucesso"
    );
}

export async function RemoverAtendimentoDoUsuarioAcompanhamentoController(
    IDCaso: number
) {
    return Controller(
        RemoverAtendimentoDoUsuarioAcompanhamentoService(IDCaso),
        "Atendimento Removido do acompanhante com sucesso"
    );
}

export async function GetAtendimentoClienteController(IDCaso: number) {
    return Controller(GetAtendimentoClienteService(IDCaso));
}

export async function ExcluirAtendimentoController(
    idCaso: number,
    idUsuario: number
) {
    return Controller(ExcluirAtendimentoService(idCaso, idUsuario));
}

export async function ListarQuantidadeAtendimentosController() {
    return Controller(ListarQuantidadeAtendimentosService());
}

export async function ListarJustificativaCancelamentoController(
    idTipoCaso: number
) {
    return Controller(ListarJustificativaCancelamentoService(idTipoCaso));
}

export async function ListarAtendimentosController(
    ID_PAGINA: number,
    SEG_ATENDIMENTOS: TModoGestaoAtendimento,
    requestBody: IListarTodosAtendimentos
) {
    return Controller(
        ListarAtendimentosService(ID_PAGINA, SEG_ATENDIMENTOS, requestBody)
    );
}

export async function ListarAtendimentosExportarExcelController(
    ID_PAGINA: number,
    SEG_ATENDIMENTOS: TModoGestaoAtendimento,
    requestBody: IListarTodosAtendimentos,
    excel?: boolean
) {
    return Controller(
        ListarAtendimentosExportarExcelService(
            ID_PAGINA,
            SEG_ATENDIMENTOS,
            requestBody,
            excel
        )
    );
}
